import { render } from "./moredata.vue?vue&type=template&id=4c3be5ff&scoped=true"
import script from "./moredata.vue?vue&type=script&lang=js"
export * from "./moredata.vue?vue&type=script&lang=js"

import "./moredata.vue?vue&type=style&index=0&id=4c3be5ff&lang=scss&scoped=true"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3be5ff"]])

export default __exports__